export const FEATURE_FLAGS = {
  showCabBonus: false,
  showCertificationReference: false,
};
